import useLocalStorage from '@rehooks/local-storage'
import { useAcessoLotacao } from 'components/auth/useAcessoLotacao'
import { Breadcrumb } from 'components/breadcrumb'
import { PageLoading } from 'components/loading'
import { PecSwitch } from 'components/route'
import { useEscutaInicialViewQuery } from 'graphql/hooks.generated'
import React from 'react'
import { Route, useRouteMatch } from 'react-router'
import { Redirect } from 'react-router-dom'

import { AtendimentoHeader, AtendimentoHeaderProps } from '../detail/AtendimentoHeader'
import { CidadaoDetailView } from '../detail/cadastro-cidadao/CidadaoDetailView'
import { FolhaRostoView } from '../detail/folha-rosto/FolhaRostoView'
import { EscutaInicialMainView } from './EscutaInicialMainView'
import { EscutaInicialState, initialValue } from './model'

interface EscutaInicialViewProps {
  atendimentoId: ID
}

export function EscutaInicialView(props: EscutaInicialViewProps) {
  const { atendimentoId } = props
  const match = useRouteMatch()
  const acesso = useAcessoLotacao()

  const {
    data: { atendimento },
    loading: isLoading,
  } = useEscutaInicialViewQuery({
    fetchPolicy: 'cache-and-network',
    variables: { atendimentoId },
  })

  const [cacheState, setCacheState, deleteCacheState] = useLocalStorage<EscutaInicialState>(
    `${acesso.id}/atendimento/escuta-inicial/${atendimentoId}`,
    initialValue()
  )

  const renderEscutaMainView = () => (
    <EscutaInicialMainView
      atendimentoId={atendimentoId}
      cidadaoId={atendimento?.cidadao?.id}
      initialValues={cacheState}
      updateCache={setCacheState}
      clearCache={deleteCacheState}
    />
  )
  const renderCidadaoDetail = () => (
    <CidadaoDetailView
      atendimentoId={atendimentoId}
      cidadaoId={atendimento?.cidadao?.id}
      clearCache={deleteCacheState}
    />
  )
  const renderFolhaRostoView = () => <FolhaRostoView atendimentoId={atendimentoId} clearCache={deleteCacheState} />

  const headerProps: AtendimentoHeaderProps = {
    cidadaoId: atendimento?.cidadao?.id,
    renderFolhaRosto: true,
    renderSoap: false,
    renderVacinacao: false,
    renderHistorico: false,
    renderAntecedentes: false,
    renderCadastroCidadao: true,
    renderEscutaInicial: true,
  }

  if (isLoading) {
    return (
      <>
        <Breadcrumb title='Escuta inicial' />
        <PageLoading message='Carregando dados da escuta inicial...' />
      </>
    )
  }

  return (
    <>
      <Breadcrumb title='Escuta inicial' />

      <AtendimentoHeader {...headerProps} />

      <PecSwitch>
        <Redirect exact path={match.url} to={`${match.url}/escuta-inicial`} />
        <Route path={`${match.url}/escuta-inicial`} render={renderEscutaMainView} />
        <Route path={`${match.url}/folha-rosto`} component={renderFolhaRostoView} />
        <Route path={`${match.url}/cadastro-cidadao`} render={renderCidadaoDetail} />
      </PecSwitch>
    </>
  )
}
